import React, { Component } from 'react';
import Delivery from './components/delivery';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';

class App extends Component {
    state = {
        voucherIds: '',
        searching: false,
        deliveries: [],
        errorMessage: '',
        inputHasError: false
    }

    // Do not allow ‘?#@ on search input
    handleInputChange = event => {
        this.setState({ voucherIds: event.target.value.replace(/[‘?#@!$%^&*()"' ]/g, ""), inputHasError: false });
    }

    formatDate(date_string) {
        let date = new Date(date_string);
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = date.getFullYear();
        let hour = String(date.getHours()).padStart(2, '0');
        let minutes = String(date.getMinutes()).padStart(2, '0');
        return [`${dd}/${mm}/${yyyy}`, `${hour}:${minutes}`];
    }

    // Add response to this.deliveries in a better format
    format_response(data) {
        let formattedData = [];
        let previousItem = data.orderStatusDetailsL[0];
        data.orderStatusDetailsL.forEach((item, index) => {
            let [date, time] = this.formatDate(item.statusDateTime);
            if (!(item.voucherId in formattedData)) {
                    if (index > 0) { // Update delivery description
                        formattedData[previousItem.voucherId].status = previousItem.statusDescription;
                        formattedData[previousItem.voucherId].statusCode = previousItem.statusCode;
                        formattedData[previousItem.voucherId].to = previousItem.destinationCity;
                        // formattedData[previousItem.voucherId].notes = previousItem.notes;
                    }

                    formattedData[item.voucherId] = {
                        "id": item.voucherId,
                        "accordionOpen": false,
                        "status": item.statusDescription,
                        "from": item.location,
                        "to": item.destinationCity,
                        "notes": "",
                        "startDateTime": {
                            "date": date,
                            "time": time
                        },
                        "points" : [{
                            "dateTime": {
                                "date": date,
                                "time": time
                            },
                            "status": item.statusDescription,
                            "statusCode": item.statusCode,
                            "location": item.location,
                            "notes": item.notes
                        }]
                    }
            }
            else {
                if (index === data.orderStatusDetailsL.length - 1) { // Update delivery description
                    formattedData[item.voucherId].status = item.statusDescription;
                    formattedData[item.voucherId].statusCode = item.statusCode;
                    formattedData[item.voucherId].to = item.destinationCity;
                    // formattedData[item.voucherId].notes = item.notes;
                }

                formattedData[item.voucherId].points.push({
                    "dateTime": {
                        "date": date,
                        "time": time
                    },
                    "status": item.statusDescription,
                    "statusCode": item.statusCode,
                    "location": item.location,
                    "notes": item.notes
                });
            }
            previousItem = item;
        });
        return formattedData;
    }

    submitForm = event => {
        if (event)
            event.preventDefault();

        this.setState({ deliveries: [], searching: true, errorMessage: "" });
        let voucherIds = this.state.voucherIds.split(',').map((x) => x.trim());
        let uniqueVoucherIds = voucherIds.filter((data, index) => data && voucherIds.indexOf(data) === index);
        let faultyVoucherIds = [];
        uniqueVoucherIds.forEach((item, index) => {
            if(item.length < 6 || item.length > 30) 
                faultyVoucherIds.push(item);
        });
        window.history.pushState({}, null, window.location.href.split('?')[0] + "?voucherIds=" + uniqueVoucherIds.join(','));
        if (uniqueVoucherIds.length > 10)
            this.setState({ searching: false, inputHasError: true, errorMessage: "<h3><strong>Όριο αριθμών αναζήτησης</strong></h3>Μπορείτε να εισάγετε μέχρι 10 αριθμούς αποστολής σε κάθε αναζήτηση." });
        else if (faultyVoucherIds.length > 0) {
            let errorMessage = "";
            if (faultyVoucherIds.length > 1)
                errorMessage = '<h3><strong>Μη έγκυρη μορφή αριθμού αποστολής</strong></h3><p>Οι αριθμοί αποστολής ';
            else
                errorMessage = '<h3><strong>Μη έγκυρη μορφή αριθμού αποστολής</strong></h3><p>Ο αριθμός αποστολής ';
            faultyVoucherIds.forEach((item, index) => {
                if (faultyVoucherIds.length > 1 && index === faultyVoucherIds.length - 1)
                    errorMessage += " και "
                else if (index > 0)
                    errorMessage += ", ";
                errorMessage += `<strong>${item}</strong>`;
            });
            if (faultyVoucherIds.length > 1)
                errorMessage += ' δεν έχουν έγκυρη μορφή.</p>';
            else
                errorMessage += ' δεν έχει έγκυρη μορφή.</p>';
            this.setState({ searching: false, inputHasError: true, errorMessage });
        }
        else {
            let jsonUniqueCodes = JSON.stringify({"specIds": uniqueVoucherIds.join(',')})
            fetch(
                    'https://tracktraceapi.sarmed.gr:9443/api/tracktrace/StatusInfoP/',
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: jsonUniqueCodes
                    }
            )
            .then( (response) => {
                if (response.status >= 400 && response.status < 600) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then( (data) => {

                // var test = {
                //     success: true,
                //     count: 2,
                //     errorCode: 5000,
                //     errorDescription: "",
                //     orderStatusDetailsL: [
                //         {
                //             destinationCity: "anw kakalia",
                //             location: "ΘΡΙΑΣΙΟ",
                //             notes: "testnotes1",
                //             statusCode: 3,
                //             statusDateTime: "2020-09-23T15:34:44.483",
                //             statusDescription: "Η παραγγελία έχει φορτωθεί",
                //             voucherId: "OR367411"
                //         },
                //         {
                //             destinationCity: "salamoura1",
                //             location: "ΘΡΙΑΣΙΟ",
                //             notes: "prwto note lathos",
                //             statusCode: 3,
                //             statusDateTime: "2020-09-23T15:34:44.483",
                //             statusDescription: "Η παραγγελία έχει φορτωθεί",
                //             voucherId: "tΠAΠΠ00075",
                //         },
                //         {
                //             destinationCity: "salamoura2",
                //             location: "Παπαγου",
                //             notes: "",
                //             statusCode: 9,
                //             statusDateTime: "2020-09-24T15:34:44.483",
                //             statusDescription: "h paraggelia vaftike",
                //             voucherId: "tΠAΠΠ00075",
                //         }
                //     ]
                // };

                // data = test;

                if (data.success) {
                    let errorMessage = "";
                    if (data.errorCode === 5001) {
                        let vouchersNotFound = data.errorDescription.split(',');
                        if (vouchersNotFound.length > 1)
                            errorMessage = `<h3><strong>Μερική εύρεση αποτελεσμάτων</strong></h3>Δεν βρέθηκαν αποτέλεσματα για τους αριθμούς αποστολής `;
                        else
                            errorMessage = `<h3><strong>Μερική εύρεση αποτελεσμάτων</strong></h3>Δεν βρέθηκε αποτέλεσμα για τον αριθμό αποστολής `;

                        vouchersNotFound.forEach((item, index) => {
                            if (vouchersNotFound.length > 1 && index === vouchersNotFound.length - 1)
                                errorMessage += " και "
                            else if (index > 0)
                                errorMessage += ", ";
                            errorMessage += `<strong>${item}</strong>`;
                        });
                        errorMessage += ".";
                    }
                    this.setState({ searching: false, errorMessage: errorMessage, deliveries: this.format_response(data) });
                }
                else
                    this.setState({ searching: false, inputHasError: true, errorMessage: "<h3><strong>Δεν βρέθηκαν αποτελέσματα</strong></h3><p>Παρακαλούμε ελέξτε ξανά τον αριθμό αποστολής της παραγγελίας σας.</p>" });
            })
            .catch((error) => {
                this.setState({ searching: false, errorMessage: "<h3><strong>Αδυναμία σύνδεσης</strong></h3>Αυτή τη στιγμή δεν είναι δυνατή η ανάκτηση αποτελεσμάτων. Παρακαλώ δοκιμάστε ξανά αργότερα." });
            })
        }
    };

    componentWillMount() {
        let name = "voucherIds";
        let results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results) {
            let voucherIds = decodeURI(results[1] || "");
            this.setState({ voucherIds }, this.submitForm);        
        }
    }

    accordionUpdate(deliveryId) {
        let newDeliveries = this.state.deliveries;
        let previousValue = newDeliveries[deliveryId].accordionOpen;
        for (const [key] of Object.entries(this.state.deliveries)) {
            newDeliveries[key].accordionOpen = false;
        }
        newDeliveries[deliveryId].accordionOpen = !previousValue;
        this.setState({ deliveries: newDeliveries })
    }

    

    render() {
        return (
            <div className="App">
                <form className="search">
                    <input
                        type="text"
                        value={this.state.voucherIds}
                        data-haserror={this.state.inputHasError}
                        onChange={this.handleInputChange}
                        placeholder="Συμπληρώστε τον αριθμό αποστολής"
                    />
                    <button
                        type="submit"
                        onClick={this.submitForm}
                        disabled={this.state.searching || !this.state.voucherIds}
                    ></button>
                </form>
                <div
                    className="deliveries"
                    data-searching={this.state.searching}
                >
                        <div className="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <div className="container">
                            {this.state.errorMessage
                                ? <div className="error" dangerouslySetInnerHTML={{__html: this.state.errorMessage}}></div>
                                : ""
                            }
                            {Object.keys(this.state.deliveries).length > 0
                                ?   Object.keys(this.state.deliveries).map((key, index) => {
                                        return <Delivery onClick={this.accordionUpdate.bind(this)} key={"delivery" + index} content={this.state.deliveries[key]} />
                                    })
                                :   ""
                            }
                        </div>
                </div>
            </div>
        )
    }
}

export default App;
